import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import classnames from 'classnames';
import React, { Component } from 'react';
import Icon from '../Icon/Icon';
import LabelAndHint from '../LabelAndHint/LabelAndHint';
var css = {
  "arrowIcon": "rui-WoKUU",
  "icon": "rui-1bxrI",
  "input": "rui-gEwdV",
  "inputDecorator": "rui-Q6xN5",
  "option": "rui-67snr"
};
var NewSelect = /*#__PURE__*/function (_Component) {
  _inherits(NewSelect, _Component);
  var _super = _createSuper(NewSelect);
  function NewSelect() {
    var _this;
    _classCallCheck(this, NewSelect);
    _this = _super.apply(this, arguments);
    _this.onChange = function (event) {
      var _a, _b;
      (_b = (_a = _this.props).onChange) === null || _b === void 0 ? void 0 : _b.call(_a, event.target.value, _this.props.name);
    };
    _this.hasChildren = function () {
      return _this.props.options || _this.props.children;
    };
    _this.renderInput = function (classname, icon, onFocus, onBlur) {
      var options = _this.props.options.map(function (option, key) {
        return /*#__PURE__*/React.createElement("option", {
          className: css.option,
          key: key,
          value: option.value
        }, option.text);
      });
      var hasChildren = _this.hasChildren();
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("select", Object.assign({
        id: _this.props.id,
        key: 'new-select',
        name: _this.props.name,
        value: _this.props.value,
        style: _this.props.style,
        className: classnames(classname, css.input),
        onChange: _this.onChange,
        disabled: _this.props.disabled,
        onBlur: onBlur,
        onFocus: onFocus
      }, _this.props.extras, {
        ref: function ref(input) {
          return _this.input = input;
        }
      }), _this.props.children || options), /*#__PURE__*/React.createElement("div", {
        className: css.inputDecorator
      }, icon, hasChildren ? /*#__PURE__*/React.createElement("div", {
        className: css.icon
      }, /*#__PURE__*/React.createElement(Icon, {
        icon: "arrowDown",
        size: 16,
        color: _this.props.disabled ? 'blackDisabled' : 'black'
      })) : null));
    };
    return _this;
  }
  _createClass(NewSelect, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(LabelAndHint, {
        id: this.props.id,
        icon: this.props.icon,
        label: this.props.label,
        value: this.props.value,
        pristine: this.props.pristine,
        hintText: this.props.hintText,
        errorText: this.props.errorText,
        disabled: this.props.disabled,
        onBlur: this.props.onBlur,
        onFocus: this.props.onFocus,
        render: this.renderInput,
        saveSpaceForIcons: this.props.saveSpaceForIcons,
        highlightOnBlur: this.props.highlightOnBlur,
        roundedInputPixel: this.props.roundedInputPixel
      });
    }
  }]);
  return NewSelect;
}(Component);
NewSelect.defaultProps = {
  className: '',
  disabled: false,
  errorText: '',
  extras: {},
  highlightOnBlur: false,
  hintText: '',
  icon: null,
  id: '',
  label: '',
  name: '',
  onBlur: function onBlur() {},
  onChange: function onChange() {},
  onFocus: function onFocus() {},
  options: [],
  pristine: true,
  saveSpaceForIcons: false,
  style: {},
  value: '',
  roundedInputPixel: false
};
export default NewSelect;